import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_82: FaireProductEntity = {
  token: "starter_collection_82",
  type: "product",
  name: "Midnight Cider Blue Apron",
  brandName: "Hedley & Bennett",
  imageUrl:
    "https://cdn.faire.com/fastly/4051f1dcda9c714e89e76d5c12875a4fa4be2ea9d7353f77a659de66ac6eb28b.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
